import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@shared/ui';

export function SelectShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.primitives.select.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.primitives.select.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <Label htmlFor="ui-library-select">{t('uiLibrary.primitives.select.label')}</Label>
        <Select defaultValue="student">
          <SelectTrigger id="ui-library-select">
            <SelectValue placeholder={t('uiLibrary.primitives.select.placeholder')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="student">
              {t('uiLibrary.primitives.select.options.student')}
            </SelectItem>
            <SelectItem value="instructor">
              {t('uiLibrary.primitives.select.options.instructor')}
            </SelectItem>
            <SelectItem value="admin">{t('uiLibrary.primitives.select.options.admin')}</SelectItem>
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
}
